<div class="PGCardsList {{selectionMode != null ? 'PGCardsList--Selectable' : ''}}">
    <div class="PGCardsList-Scrollable">
        @for (element of dataRows; track element) {
            <div class="PGCardsList-Element pg-animation-slidedown" (click)="toggleSelection(element.id)">
                @if (elementBadges != null) {
                    <div class="PGCardsList-Element-Badges">
                        @for (badge of elementBadges; track badge) {
                            @if (badge.isVisible(element)) {
                                <span
                                    class="badge bg-{{badge.color != null ? badge.color : 'primary'}} me-1">
                                    @if (badge.icon) {
                                        <i class="{{badge.icon}}"></i>
                                    }
                                    @if (badge.icon != null && badge.label != null) {
                                        &nbsp;
                                    }
                                    @if (badge.label) {
                                        <span>{{badge.label}}</span>
                                    }
                                </span>
                            }
                        }
                    </div>
                }
                <div class="PGCardsList-Element-Actions">
                    @if (elementActions == null) {
                        @if (actions.edit) {
                            <button class="btn btn-sm btn-primary ms-1" (click)="editElement(element)"><i class="fa-regular fa-edit"></i></button>
                        }
                    }
                    @if (elementActions != null) {
                        @for (action of elementActions; track action) {
                            @if (action.children == null && (action.isVisible == null || action.isVisible(element))) {
                                <button
                                    class="btn btn-sm btn-{{action.color != null ? action.color : 'primary'}} ms-1"
                                    (click)="action.onAction(element)">
                                    @if (action.icon) {
                                        <i class="{{action.icon}}"></i>
                                    }
                                    @if (action.label) {
                                        <span>{{action.label}}</span>
                                    }
                                </button>
                            }
                            @if (action.children != null) {
                                <span ngbDropdown>
                                    <button class="btn btn-sm btn-{{action.color != null ? action.color : 'primary'}} ms-1" ngbDropdownToggle>
                                        @if (action.icon) {
                                            <i class="{{action.icon}}"></i>
                                        }
                                        @if (action.label) {
                                            <span>{{action.label}}</span>
                                        }
                                    </button>
                                    <div ngbDropdownMenu>
                                        @for (child of action.children; track child) {
                                            @if (child.isVisible == null || child.isVisible(element)) {
                                                <button class="dropdown-item btn {{child.color != null ? 'text-' + child.color : ''}}" (click)="child.onAction(element)">
                                                    @if (child.icon) {
                                                        <i class="{{child.icon}}"></i>
                                                    }
                                                    @if (child.label) {
                                                        <span>{{child.label}}</span>
                                                    }
                                                </button>
                                            }
                                        }
                                    </div>
                                </span>
                            }
                        }
                    }
                </div>
                <div class="PGCardsList-Element-Card">
                    <app-pg-semantic-view-card [resourceId]="resourceId" [elementData]="element" [useCache]="cache"></app-pg-semantic-view-card>
                </div>
            </div>
        }
        <div class="PGCardsList-LoadMore">
            <app-pg-view-more [hidden]="isLoadingData || isAtEnd" (viewMore)="loadData()"></app-pg-view-more>
        </div>
        <div class="PGCardsList-Loading {{isLoadingData ? 'PGCardsList-Loading--Show' : '' }}">
            <app-pg-loading></app-pg-loading>
        </div>
    </div>
</div>